import React, { useMemo, Fragment } from "react";
import orderBy from "lodash/orderBy";
import FileRow from "components/cartografia/list-view/FileRow";

const ListView = props => {
  const {
    medias,
    folders,
    isViewFolder,
    currentFolder,
    openFileORFolder,
    deleteFolder,
    deleteFile,
    moveToFolder,
    moveFiletoRoot,
    openRenameFolderModal,
    isViewSubfolder, // Adiciona isViewSubfolder
    currentSubfolder // Adiciona currentSubfolder
  } = props;

  const rootMedias = useMemo(() => {
    return orderBy(
      medias.filter(a => a.folder_id === null),
      ["created"],
      ["desc"]
    );
  }, [medias]);

  const folderMedias = useMemo(() => {
    if (isViewFolder) {
      if (isViewSubfolder && currentSubfolder) {
        // Se isViewSubfolder for verdadeiro e houver uma subpasta atual (currentSubfolder)
        return orderBy(
          medias.filter(
            a =>
              a.folder_id === currentFolder.id ||
              a.folder_id === currentSubfolder.id
          ),
          ["created"],
          ["desc"]
        );
      } else {
        // Se isViewSubfolder for falso ou não houver uma subpasta atual (currentSubfolder)
        return orderBy(
          medias.filter(a => a.folder_id === currentFolder.id),
          ["created"],
          ["desc"]
        );
      }
    }
    return [];
  }, [medias, isViewFolder, currentFolder, isViewSubfolder, currentSubfolder]);

  const orderedFolders = useMemo(
    () => orderBy(folders, ["created"], ["desc"]),
    [folders]
  );

  return (
    <div className="list-media-container">
      <table className="fill-width list-view-table">
        <tbody>
          <tr>
            <th>Nome</th>
            <th>Criado em</th>
            <th></th>
          </tr>
          {isViewFolder || isViewSubfolder ? ( // Verifica isViewFolder ou isViewSubfolder
            <Fragment>
              {folderMedias && folderMedias.length ? (
                folderMedias.map(media => {
                  return (
                    <FileRow
                      type="image"
                      key={media.id}
                      media={media}
                      openFileORFolder={openFileORFolder}
                      deleteFolder={deleteFolder}
                      deleteFile={deleteFile}
                      isViewFolder={isViewFolder}
                      isViewSubfolder={isViewSubfolder} // Passa isViewSubfolder
                      currentSubfolder={currentSubfolder} // Passa currentSubfolder
                      moveToFolder={moveToFolder}
                      moveFiletoRoot={moveFiletoRoot}
                      openRenameFolderModal={openRenameFolderModal}
                    />
                  );
                })
              ) : (
                <div className="mlr-auto ptb-30">
                  <div className="empty-folder">
                    <div className="fs-16 demi-bold-text pt-10">
                      Empty Folder
                    </div>
                  </div>
                </div>
              )}
            </Fragment>
          ) : (
            <Fragment>
              {orderedFolders &&
                orderedFolders.map(folder => {
                  return (
                    <FileRow
                      type="folder"
                      key={folder.id}
                      media={folder}
                      openFileORFolder={openFileORFolder}
                      deleteFolder={deleteFolder}
                      deleteFile={deleteFile}
                      isViewFolder={isViewFolder}
                      isViewSubfolder={isViewSubfolder} // Passa isViewSubfolder
                      currentSubfolder={currentSubfolder} // Passa currentSubfolder
                      moveToFolder={moveToFolder}
                      moveFiletoRoot={moveFiletoRoot}
                      openRenameFolderModal={openRenameFolderModal}
                    />
                  );
                })}
              {rootMedias &&
                rootMedias.map(media => {
                  return (
                    <FileRow
                      type="image"
                      key={media.id}
                      media={media}
                      openFileORFolder={openFileORFolder}
                      deleteFolder={deleteFolder}
                      deleteFile={deleteFile}
                      isViewFolder={isViewFolder}
                      isViewSubfolder={isViewSubfolder} // Passa isViewSubfolder
                      currentSubfolder={currentSubfolder} // Passa currentSubfolder
                      moveToFolder={moveToFolder}
                      moveFiletoRoot={moveFiletoRoot}
                      openRenameFolderModal={openRenameFolderModal}
                    />
                  );
                })}
            </Fragment>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ListView;
